export default __webpack_public_path__ + "static/media/image_12.09b5c2be.jpg";